import React, { useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
    CircularProgress,
    Box
} from '@mui/material';
import { submitReport } from '@app/model';

interface ReportSubmitModalProps {
    open: boolean;
    onClose: () => void;
    onSuccess?: () => void; // Optional: callback on successful submission
}

export const ReportSubmitModal: React.FC<ReportSubmitModalProps> = ({ open, onClose, onSuccess }) => {
    const [mobile, setMobile] = useState('');
    const [reason, setReason] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        // Reset state on close
        setMobile('');
        setReason('');
        setError('');
        setLoading(false);
        onClose();
    };

    const handleSubmit = async () => {
        if (!mobile || !reason) {
            setError('手机号和举报原因均不能为空。');
            return;
        }
        setError('');
        setLoading(true);

        try {
            const result = await submitReport({
                reported_mobile: mobile,
                reason: reason,
                report_type: 'user_report_from_app', // or make this dynamic if needed
            });

            if (result.shellIsOk) {
                // alert('举报成功，感谢您的反馈！'); // Or use a Snackbar for better UX
                if (onSuccess) {
                    onSuccess();
                }
                handleClose();
            } else {
                setError(result.err?.message || '提交失败，请稍后再试。');
            }
        } catch (e) {
            setError('网络错误，请检查您的连接。');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>提交举报</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    请输入您要举报的用户的手机号码和具体原因。我们会尽快处理您的举报。
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="mobile"
                    label="被举报人手机号、账号或ID"
                    type="tel"
                    fullWidth
                    variant="standard"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    disabled={loading}
                />
                <TextField
                    margin="dense"
                    id="reason"
                    label="举报原因"
                    type="text"
                    fullWidth
                    multiline
                    rows={4}
                    variant="standard"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    disabled={loading}
                />
                {error && (
                    <Box sx={{ color: 'error.main', mt: 2 }}>
                        {error}
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={loading}>取消</Button>
                <Button onClick={handleSubmit} disabled={loading}>
                    {loading ? <CircularProgress size={24} /> : '提交'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

